"use strict";

var _ = require("underscore");
var Reflux = require("reflux");
var FunnelSelectFilterActions = require("../actions/funnel-select-filter-actions.js");

var FunnelSelectFilterStore = Reflux.createStore({
  state: {
    funnels: []
  },
  setState: function(state){
    this.state = state;
    this.trigger(this.state);
    return this.state;
  },
  getInitialState: function() {
    return {
      funnels: []
    };
  },
  init: function(){
    this.listenTo(FunnelSelectFilterActions.loadFunnels.completed, this.onLoadFunnelsCompleted);
    this.state = this.getInitialState();
  },
  onLoadFunnelsCompleted: function(funnels){
    this.state.funnels = funnels;
    this.trigger(this.state);
  },
});

module.exports = FunnelSelectFilterStore;



// WEBPACK FOOTER //
// ./app/shared/stores/funnel-select-filter-store.js